<template>
  
  <button aria-hidden="true" class="btn-reset cta-circle d-flex flex-column align-items-center justify-content-center" v-on:click="ctaClicked">
    <SVGArrow class="arrow" :class="{'down': down, 'purple': purple}"></SVGArrow>
  </button>
  
</template>

<script>
import SVGArrow from '@/assets/icons/arrow.svg'

export default {
  name: 'CtaCircleSmall',
  components: {
    SVGArrow
  },
  props: [
    'purple',
    'down'
  ],
  methods: {
      ctaClicked(){
          this.$emit('clicked')
      }
  }
}
</script>

<style scoped>
.cta-circle{
    width: 60px;
    height: 60px;
    min-width: 60px;
    min-height: 60px;
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid #979797;
}
svg g {
  fill: #ed7530;
}
svg.purple g {
   fill: #7575bf;
}
.arrow {
  width: 25px;
}
.arrow.down {
    transform: rotate(90deg);
}
</style>

